import { render } from "./accidentHealth.vue?vue&type=template&id=36748149&scoped=true"
import script from "./accidentHealth.vue?vue&type=script&lang=js"
export * from "./accidentHealth.vue?vue&type=script&lang=js"

import "./accidentHealth.vue?vue&type=style&index=0&id=36748149&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36748149"]])

export default __exports__